module.exports = __webpack_public_path__ + "static/media/taiwanlog.d0386119.png";